import { removeLocalStorageItem, setLocalStorageItem } from "../../../utils/HelperFunctions";
/**redirect flow */
export const azureLogout = (msalInstance, activeAccount) => {
    return new Promise((resolve, reject) => {
        setLocalStorageItem("logoutInProgress", true);
        msalInstance.logoutRedirect({
            account: activeAccount
            // logoutHint: activeAccount.homeAccountId 
        })
            .then(() => {
                resolve(); // Resolve the promise if logout succeeds
            })
            .catch(error => {
                removeLocalStorageItem("logoutInProgress");
                console.error('Error during Azure logout:', error);
                reject(error); // Reject the promise if there's an error - handle in catch()
            });
    });
};


export const checkIfUserExistsInArcGISPortal = async (username, portalUrl, azureToken) => {
    try {
        

        /**using public endpoint */
        let arcgisResponse;
        if (azureToken) {
            arcgisResponse = await fetch(
                `${portalUrl}/sharing/rest/community/users/${username}?f=json`,
                {
                    // headers: {
                    //     Authorization: `Bearer ${azureToken}`,
                    // },
                    method: "GET",
                    params: { azureToken}
                }
            );
            if(!arcgisResponse){
                arcgisResponse = await fetch(
                    `${portalUrl}/sharing/rest/community/users/${username}?f=json&token=${azureToken}`,
                    {
                        // headers: {
                        //     Authorization: `Bearer ${azureToken}`,
                        // },
                        method: "GET",
                        // params: { azureToken}
                    }
                );
            }
        } else {
            arcgisResponse = await fetch(
                `${portalUrl}/sharing/rest/community/users/${username}?f=json`,
                {
                    method: "GET",
                }
            );
        }
        if(!arcgisResponse){
            return false;
        }
        const data = await arcgisResponse.json();
        if (data.error) {
            console.log('User not found in portal:', data.error);
            return false;
        }
        return true;

    } catch (error) {
        console.error('Error checking user in portal:', error);
        return false; 
    }
};

export const redirectToIDP = (portalUrl, samlLogin, appID) => {
    /**redirect to IDP */
    try {
        // Ensure portalUrl and samlLogin are valid URLs
        const baseUrl = new URL(portalUrl);
        const loginPath = samlLogin.startsWith("/") ? samlLogin.substring(1) : samlLogin;

        // Construct the final login URL safely
        const samlLoginUrl = new URL(`portal/sharing/rest/${loginPath}`, baseUrl);

        // Construct redirect_uri
        const redirect_uri = window.location.origin + window.location.pathname;

        // Construct search parameters
        const samlLoginParams = new URLSearchParams({
            client_id: appID,
            response_type: "token",
            redirect_uri: redirect_uri,
        });

        const finalUrl = `${samlLoginUrl.toString()}?${samlLoginParams.toString()}`;
        // Redirect safely
        window.location.href = finalUrl;
    } catch (error) {
        console.log("Invalid IDP URL: ", error);
    }
    
}